export default __webpack_public_path__ + "static/jabber-100309b1e49023b7ece0644dd79e158a.gif";